export default __webpack_public_path__ + "static/media/mode-2041.01abfa85.svg";